import { Box, styled } from '@mui/material';
import React from 'react';

import Card from '../../base/card';
import Spacer, { spc } from '../../base/spacer';

import Text from '~c/components/base/text/index';

interface Props {
  className?: string;
  value: any;
  name: string;
  color: string;
  description?: string;
}

const ProjectDimension: React.FC<Props> = ({
  className,
  value,
  name,
  description,
  color,
}) => {
  return (
    <Card className={className}>
      <Box className="border-left">
        <Text sz="h1" color={color}>
          {value.toFixed(2)}
        </Text>
        <Spacer pb={spc.xxxs} />
        <Text sz="body14" color="secondary">
          {name}
        </Text>
        <Spacer pb={spc.xs} />
        <Text sz="body12" color="secondary">
          {description}
        </Text>
      </Box>
    </Card>
  );
};

export default styled(ProjectDimension)`
  .border-left {
    border-left: ${(props) =>
      props.color ? `2px solid ${props.color}` : '2px solid'};
    padding-left: 10px;
  }
`;
